module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288.3 144.3"><path class="st5" fill="#fff" stroke="#000" stroke-width=".25" d="M72.1 48.1h216v48h-216z"/><path class="st6" fill="#007a4d" stroke="#000" stroke-width=".25" d="M72.1.1h216v48h-216z"/><path class="st7" stroke="#000" stroke-width=".25" d="M72.1 96.1h216v48h-216z"/><path class="st8" fill="#e95123" stroke="#000" stroke-width=".25" d="M.1.1h72v144H.1z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/flag/flg9.svg
// module id = 527
// module chunks = 1